<template>
  <div id='bd-main'>
    <el-table :data="rates.content" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="visitor.nickname" label="访客" width="185"></el-table-column>
      <el-table-column prop="agent.realName" label="客服" width="185"></el-table-column>
      <el-table-column prop="score" label="评分"></el-table-column>
      <el-table-column prop="note" label="备注"></el-table-column>
      <el-table-column prop="invite" label="邀请评价"></el-table-column>
      <el-table-column prop="client" label="客户端"></el-table-column>
      <el-table-column prop="createdAt" label="时间"></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="120">
        <!-- <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteRow(scope.$index, tableData)"
            type="text"
            size="small">
            查看
          </el-button>
        </template> -->
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="10"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="rates.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'bd-main',
  data () {
    return {
      resize: true
    }
  },
  computed: {
    ...mapGetters([ 'rates' ])
  },
  methods: {
    ...mapActions([ 'getRates' ]),
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let payload = { page: val - 1, size: 10 }
    this.getRates(payload)
    }
  },
  created() {
    let payload = { page: 0, size: 10 }
    this.getRates(payload)
  },

}
</script>

<style scoped>

</style>
